import { makeVar, useReactiveVar } from "@apollo/client";
import { useMatch, useNavigate, useSearch } from "react-location";

import Cookies from "js-cookie";
import { LocationGenerics } from "router/location";
import { VisalLogin_login_user } from "_graphql/visal/mutations/__generated__/VisalLogin";
import Permissions from "_graphql/data/app-permissions";
import config from "config";

export const UserPermissions = Permissions.map(({ value }) => value);
export const UserRoles = Permissions.map(({ value }) => value);
export type UserPermission = (typeof UserPermissions)[number];
export type Domain = "Visal" | "KEK";
export type UserRole = (typeof UserPermissions)[number];

export const isLoggedInVar = makeVar<boolean>(
    !!Cookies.get(`visalre:auth:token`),
);
export const languageVar = makeVar<boolean>(
    !!Cookies.get(`visalre:app:language`),
);
export const currentTokenVar = makeVar<string | null>(
    localStorage.getItem(`visalre:auth:token`) || null,
);

export const currentAgentTokenVar = makeVar<string | null>(
    localStorage.getItem(`visalre:auth:agent-token`),
);
export const currentUserVar = makeVar<VisalLogin_login_user>(
    JSON.parse(localStorage.getItem(`visalre:auth:user`) ?? "{}") ?? null,
);

export const currentPlaceItDisplayCountVar = makeVar<number>(0);

export const useCurrentPlaceItDisplayCount = () =>
    useReactiveVar(currentPlaceItDisplayCountVar);
export const useCurrentUser = () => useReactiveVar(currentUserVar);
export const useCurrentLanguage = () => useReactiveVar(languageVar);
export const useAppSearch = () => useSearch<LocationGenerics>();
export const useAppLocation = () => useMatch<LocationGenerics>();
export const useAppNavigate = () => useNavigate<LocationGenerics>();
export const currentPushTokenVar = makeVar<string | null>(
    Cookies.get(`visalre:auth:push-token`) || null,
);

export const setAuth = ({
    user,
    token,
    agentToken,
}: {
    user: VisalLogin_login_user;
    token: string;
    agentToken: string;
}) => {
    currentUserVar(user);
    localStorage.setItem(`visalre:auth:user`, JSON.stringify(user));
    isLoggedInVar(true);
    currentTokenVar(token);
    localStorage.setItem(`visalre:auth:token`, token);
    currentAgentTokenVar(agentToken);
    localStorage.setItem(`visalre:auth:agent-token`, agentToken);
};

export const setMe = (user: VisalLogin_login_user) => {
    currentUserVar(user);
    localStorage.setItem(`visalre:auth:user`, JSON.stringify(user));
};

export const setPushToken = (token: any) => {
    currentPushTokenVar(token);
    Cookies.set(`visalre:auth:push-token`, token, {
        ...config.cookies,
        expires: 1,
        secure: true,
        sameSite: "strict",
    });
};

export const clearAuth = () => {
    isLoggedInVar(false);
    currentTokenVar(null);
    currentUserVar(undefined);
    localStorage.clear();
};
